
import axios from "axios";
import { store } from "store";
import { OutputBaseProps, PaginationProps } from "utils/types/API";
import { PostItemProps } from ".";
import { loading, index, relate } from "store/post";

interface ApiPostInputProps {
    page: number;
    pageSize: number;
    q?: string;
    topicIds?: number[];
    publish?: boolean;
    order?: "old"
}

type ApiPostOutputProps = OutputBaseProps<{ list: PostItemProps[]; pagination?: PaginationProps; }>;

export const apiPostIndex = async (data: ApiPostInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiPostOutputProps>("/api/posts", { params: data }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(index({ data: res.data.list, pagination: res.data.pagination }));
    }
    return res;
};


export const apiPostRelate = async (data: ApiPostInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiPostOutputProps>("/api/posts", { params: data }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(relate({ data: res.data.list }));
    }
    return res;
};